import { createEvent } from "@cobuildlab/react-simple-state";
/* @ts-ignore */
import { Version } from "@devsplan/wealthclub-shared";

export const OnFetchVersions = createEvent<Version[]>();
export const OnFetchVersionsError = createEvent();

export const OnCreateVersion = createEvent();
export const OnCreateVersionError = createEvent();
